// Per-user preference for how due dates / deadlines are shown: "relative" = the
// default relative phrasing ("in 5 Tagen", "Heute", "überfällig"); "absolute" =
// a fixed date (TT.MM.JJJJ). Stored per browser (≈ per user), shared across every
// board + view, and applied wherever relDate renders a due date. The overdue /
// today / late COLOUR semantics are unaffected — only the label text changes.
// Mirrors detailViewMode (localStorage, no backend, no cross-device sync).
export type DateFormatMode = "relative" | "absolute";

const KEY = "flow.date.format";

export function loadDateFormat(): DateFormatMode {
  try {
    return localStorage.getItem(KEY) === "absolute" ? "absolute" : "relative";
  } catch {
    return "relative";
  }
}

export function saveDateFormat(mode: DateFormatMode): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* ignore quota/availability errors — the preference just won't persist */
  }
}
